export type RuntimeConfig = {
  apiUrl: string;
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  cognitoDomain: string;
  eventId: string;
};

const localConfig: RuntimeConfig = {
  apiUrl: import.meta.env.VITE_API_URL || "http://localhost:3001",
  region: import.meta.env.VITE_AWS_REGION || "us-east-1",
  userPoolId: import.meta.env.VITE_USER_POOL_ID || "",
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || "",
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN || "",
  eventId: "RCCFD2026-OCT24",
};

export async function loadConfig(): Promise<RuntimeConfig> {
  try {
    const response = await fetch("/config.json", { cache: "no-store" });
    if (!response.ok) return localConfig;
    return { ...localConfig, ...(await response.json()) };
  } catch {
    return localConfig;
  }
}
